import React from 'react';
import GraphsSection from '../GraphsSection';
import './ConnectorEvaluationGraphs.css';

export interface ConnectorEvaluationGraphsProps {
  isOptimizing?: boolean;
  progress?: number;
  requestedIterations?: number;
  /** Метрика, по которой идёт отбор кандидата ('quality' | 'tokens' | 'cost') — для подписи графика. */
  primaryMetricId?: string;
}

const ConnectorEvaluationGraphs: React.FC<ConnectorEvaluationGraphsProps> = ({
  isOptimizing = false,
  progress = 0,
  requestedIterations,
  primaryMetricId,
}) => {
  return (
    <section className="connector-eval-graphs">
      <header className="connector-eval-graphs__header">
        <div>
          <span className="connector-eval-graphs__eyebrow">Metrics</span>
          <h2 className="connector-eval-graphs__title">Evaluation</h2>
          <p className="connector-eval-graphs__subtitle">
            Track iteration quality and embedding space as optimization progresses.
          </p>
        </div>
        {isOptimizing && (
          <div className="connector-eval-graphs__progress">
            <span className="connector-eval-graphs__progress-dot" aria-hidden />
            {progress.toFixed(1)}% complete
          </div>
        )}
      </header>
      <div className="connector-eval-graphs__body">
        <GraphsSection
          isOptimizing={isOptimizing}
          progress={progress}
          isMultiAgent
          isConnector
          requestedIterations={requestedIterations}
          primaryMetricId={primaryMetricId}
        />
      </div>
    </section>
  );
};

export default ConnectorEvaluationGraphs;
